import { render } from "./cursor.vue?vue&type=template&id=f2ac2580"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/cursor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2ac2580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2ac2580', __exports__)) {
    api.reload('f2ac2580', __exports__)
  }
  
  module.hot.accept("./cursor.vue?vue&type=template&id=f2ac2580", () => {
    api.rerender('f2ac2580', render)
  })

}


export default __exports__